var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0346 6.16732H11.0465V0.801324C10.4617 -0.391119 9.51498 0.00636177 9.1147 0.354158L0.186757 13.2723C-0.356229 14.107 0.413001 14.6469 0.865489 14.8125H9.01028V19.9798C9.42796 21.5697 10.7854 20.9735 11.0465 20.3773L18.7736 9.29748C20.862 6.99209 19.8178 6.25013 19.0346 6.16732Z",
    fill: "#057DBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouthLogo);
export default __webpack_public_path__ + "static/media/youthLogo.6c066f4bbf82e1e5bbac568a22b5a11d.svg";
export { ForwardRef as ReactComponent };